<template>
  <div class="container">
    <div class="container__body">
      <div class="container__img">
        <img :src="require('@/assets/img/user.svg')" alt />
      </div>
      <div class="container__datos">
        <div class="container__datos-nombres" @click="$emit('select-employee')">
          {{ employee.firstName }} {{ employee.firstSurname }}
          {{ employee.secondSurname }}
        </div>
        <div class="container__datos-cargo">
          <i
            class="field-data"
            >Cargo: {{
              employee.tregister.professionalPosition
              }}</i
          >
        </div>
        <div class="container__datos-fono">
          <i class="field-data">Teléfono: {{ employee.tregister.phone }}</i>
        </div>
        <div class="container__datos-fono">
          <i class="field-data"> {{cessation ? 'F. de cese:' : 'F. de ingreso:'}} {{ admittedDate }}</i>
        </div>
      </div>
      <div class="container__tools">
        <i class="icon-edit" @click="$emit('select-employee')"></i>
      </div>
    </div>
    <div class="container__footer">
      <slot></slot>
      <slot name="control"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "cardEmployee",
  props: {
    employee: {
      type: Object,
      required: true
    },
    cessation: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    admittedDate(){
      return new Date(this.employee.tregister.admittedAt).toLocaleDateString('es-PE')
    }
  }
};
</script>

<style lang="scss" scoped>
//1-SETTINGS
//colors
$b-orange: #d8ff00;
$b-blue: #000000;
$b-emph: #97c2c9;
//breakpoints
$sm: 600px;
$md: 900px;
$lg: 1200px;
$xl: 1800px;
//variables
$p-img: "../assets/img/";

//3-TOOLS
//functions
//background-image function
@function bimg($img) {
  @return url($p-img+$img);
}
//mixins
@mixin mq($min-width) {
  @media screen and (min-width: $min-width) {
    @content;
  }
}
.container {
      width: 24rem;
      height: 9rem;
      background-color: #fff;
      margin-bottom: 1rem;
      border-radius: 0.5rem;
      @include mq("800px") {
        margin: 0.6rem 1.2rem;
      }
      &__body {
        height: 75%;
        border-bottom: 1px solid #d7dae2;
        display: flex;
        justify-content: flex-start;
        padding: 1rem 1rem 0 1rem;
      }
      &__img {
        flex-shrink: 0;
        height: 3rem;
        width: 3rem;
        border-radius: 100%;
        margin: 0 1rem;
        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }
      }
      &__datos {
        // margin-left: -0.5rem;
        min-width: 200px;
        &-nombres {
          font-weight: 700;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          @include mq($lg) {
            cursor: pointer;
          }
        }
        &-cargo {
          display: flex;
          justify-content: space-between;
          color: rgba(#43425d, 0.5);
        }
        &-fono {
          display: flex;
          justify-content: space-between;
          color: rgba(#43425d, 0.5);
        }
      }
      &__tools {
        color: #a4afb7;
        margin-left: auto;
        .icon-edit {
          @include mq($lg) {
            cursor: pointer;
          }
        }
        .icon-close {
          margin-left: 0.5rem;
        }
      }
      &__footer {
        height: 25%;
        display: flex;
        justify-content: center;
        align-items: center;
        i {
          color: #cecfd0;
          font-size: 1.5rem;
          margin: 0 1rem;
        }
      }
    }
    .field-data {
          width: 100%;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    }
</style>
